export default class Clico {
    constructor(){
        this.id = null;
        this.descricao = null;
        this.diasTrabalhados = null;
        this.diasFolgas = null;
        this.fatorRepeticao = null;
        this.posicao = null;
        this.entrada1 = null;
        this.saida1 = null;
        this.entrada2 = null;
        this.saida2 = null;
        this.entrada3 = null;
        this.saida3 = null
    }
}